export enum ReservationResponse {
  Lemondhato = 0,
  NemLehetLemondaniMertUtkozesVan = 1,
}
